import { Controller } from "@hotwired/stimulus"
import i18n from "../javascripts/util/i18n"

// Live password / confirmation match check. Shows an inline error and blocks
// submit (via setCustomValidity) the moment the two fields diverge, so the
// mismatch surfaces while typing instead of only after a failed save.
export default class extends Controller {
  static targets = ["password", "confirmation", "error"]

  connect() {
    this.check()
  }

  check() {
    if (!this.hasPasswordTarget || !this.hasConfirmationTarget) return

    const password = this.passwordTarget.value
    const confirmation = this.confirmationTarget.value
    const mismatch = confirmation.length > 0 && password !== confirmation

    if (this.hasErrorTarget) this.errorTarget.classList.toggle("hidden", !mismatch)
    this.confirmationTarget.setCustomValidity(mismatch ? i18n.t("js.password_match.mismatch") : "")
  }
}
